import { render, staticRenderFns } from "./EntrustWrapper.vue?vue&type=template&id=f08db406"
import script from "./EntrustWrapper.vue?vue&type=script&lang=ts"
export * from "./EntrustWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports